/** 龙之谷账号迁移业务 */
import { Platform } from '@/enums';
import { transferDN2Account } from '@/api/transfer';

export default {
    methods: {
        transferAccount(accountInfo) {
            const { appId, regionId, channelId, openId, platform, token, encodeParam } =
                accountInfo;
            const fromGame = platform === Platform.WebViewTransfer ? 1 : 0;
            let status = 1;
            transferDN2Account({
                appId,
                channelId,
                fromGame,
                regionId,
                ...(fromGame === 1 ? { encodeParam } : { openId, token }),
            })
                .catch(() => {
                    status = 0;
                })
                .finally(() => {
                    this.$router.push({
                        name: 'transferResult',
                        query: {
                            regionId,
                            isMigrated: 0,
                            status,
                        },
                    });
                });
        },
    },
};
